import { useEffect } from "react"
import { useResultPopupModuleDispatch } from "../../result-popup"
import { useUserModuleState, USER_MODULE_ACTION, useUserModuleDispatch } from "..";
import useGtagEvent from "../../../utils/google-analitics/use-gtag-event";
import { GAME_DURATION } from "../../../config";

export default function useCompleteGameCheck() {

    const dispatchPopup = useResultPopupModuleDispatch();
    const dispatchUser = useUserModuleDispatch();
    const { gameEndSended, gameStartTime } = useUserModuleState();
    const { tracks } = useUserModuleState();
    const sendEvent = useGtagEvent()

    useEffect(() => {
        if (tracks.filter(t => t.status === 'lost' || t.status === 'completed').length === 5) {


            dispatchUser({ type: USER_MODULE_ACTION.GAME_END })

            if (!gameEndSended) {

                const time = gameStartTime ? Math.floor((GAME_DURATION - (Date.now() - gameStartTime)) / 1000) : 0;
                const minutes = Math.floor(time / 60);
                const seconds = time % 60;
                const timeString = `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;

                const complete = tracks.filter(t => t.status === 'completed').length;
                const lost = tracks.filter(t => t.status === 'lost').length;


                sendEvent('game_complete', `${complete}_${lost}_${timeString}`)
                dispatchUser({ type: USER_MODULE_ACTION.END_GAME_SENDED })
            }
        }
    }, [tracks, dispatchPopup, dispatchUser, gameEndSended, sendEvent, gameStartTime])
}
